import React from 'react';
import Button from '../../../../incase-domain/components/button/Button';
import DropdownMenuCompact from '../../../../incase-domain/components/dropdownMenuCompact/DropdownMenuCompact';
import {DropdownMenuCompactTileProps} from '../../../../incase-domain/components/dropdownMenuCompact/DropdownMenuCompactTile';

interface PageHeaderProps {
    title?: string;
    items?: DropdownMenuCompactTileProps[];
    trailing?: React.ReactNode;
    defaultIndex?: number;
}

function PageHeader(props: PageHeaderProps): JSX.Element {
    const {title, items, trailing, defaultIndex} = props;

    return (
        <div className="c-pageHeader">
            <div className="c-pageHeader__title">{title}</div>
            {items && items.length > 0 && defaultIndex !== undefined && (
                <DropdownMenuCompact items={[items]}>
                    <Button variant="soft" size="xs" color="secondary" trailing="solar:alt-arrow-down-linear">
                        {items[defaultIndex].label}
                    </Button>
                </DropdownMenuCompact>
            )}
            {trailing && <div className="c-pageHeader__trailing">{trailing}</div>}
        </div>
    );
}
export default PageHeader;
